import { useCallback, useState } from 'react'
import { Pharmacist } from '@/features/auth/types/pharmacy'
import { localStorageWrapper } from '@/shared/helpers/localStorage'

interface UseSessionPharmacistReturn {
  sessionPharmacistId: string
  setSessionPharmacistId: (id: string) => void
}

/**
 * セッション単位（localStorage 永続）で選択中の担当薬剤師 ID を管理する。
 * - 録音前の編集可能 Select 用途
 * - 録音後イベントの担当表示は event 側 (patientDetail.pharmacist_*) を使うこと
 * - pharmacistList ロード後、stale ID は list の先頭に寄せる
 */
export function useSessionPharmacist(
  pharmacistList: Pharmacist[]
): UseSessionPharmacistReturn {
  const [sessionPharmacistId, setStateRaw] = useState<string>(
    () => localStorageWrapper.getItem('sessionPharmacistId') || ''
  )

  const setSessionPharmacistId = useCallback((id: string) => {
    setStateRaw(id)
    localStorageWrapper.setItem('sessionPharmacistId', id)
  }, [])

  // stale ID 解決（list に存在しない ID を先頭に寄せる）
  if (pharmacistList.length > 0) {
    const isValid = pharmacistList.some((p) => p.id === sessionPharmacistId)
    if (!isValid) {
      const fallback = pharmacistList[0].id
      if (fallback !== sessionPharmacistId) {
        setSessionPharmacistId(fallback)
      }
    }
  }

  return { sessionPharmacistId, setSessionPharmacistId }
}
